module.exports = __webpack_public_path__ + "2b1d5aa34ddb2dc385c32ee84ccefd65.svg";